<div class="nv-hig" fxFlex="row" fxLayoutAlign="start start">
    <mat-slider
        #slider
        fxFlex
        [min]="min"
        [max]="max"
        [step]="step"
        [disabled]="disabled"
        [discrete]="thumbLabel"
        [showTickMarks]="showTickMarks"
        [class.cdk-mouse-focused]="textFocused"
        [class.nv-mouse-down]="mouseDown"
        (mousedown)="mouseDown = true"
        (window:mouseup)="mouseDown = false"
        (keydown)="onKeyDown($event)"
        [class.hig-slider-no-animation]="animating || initializing"
        tabindex="-1"
        nvMatSliderKeyboardFixup
    >
        <input
            matSliderThumb
            [(ngModel)]="value"
            (input)="sliderChanged()"
            [attr.aria-label]="ariaLabel || value"
            [attr.tabindex]="tabindex"
        />
    </mat-slider>
    @if (valueEntry) {
        <input
            #textEntry
            type="text"
            fxFlex="none"
            class="slider-text-entry font-body2"
            [disabled]="disabled"
            [ngModel]="inputValue"
            (focus)="onTextFocus()"
            (blur)="onTextBlur()"
            (ngModelChange)="textInput($event, textEntry)"
            (change)="textChanged($event)"
            [attr.tabindex]="tabindex"
            [attr.aria-label]="ariaLabel"
        />
    }
</div>
